import { Badge, Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';

interface CardProps {
    name: string;
    status: 'UP' | 'DOWN' | 'UNKNOWN';
}

const statusColorScheme: { [key: string]: string } = {
    UP: 'green',
    DOWN: 'red',
    UNKNOWN: 'gray'
};

const Card: React.FC<CardProps> = ({ name, status }) => {
    const color = statusColorScheme[status] || 'gray';

    return (
        <Box
            bg="white"
            p="6"
            borderRadius="md"
            boxShadow="md"
            borderLeftWidth="5px"
            borderLeftColor={`${color}.400`}
            transition="transform 0.2s"
            _hover={{
                transform: 'translateY(-5px)',
                boxShadow: 'lg'
            }}
        >
            <Flex justifyContent="space-between" alignItems="center">
                <Text fontSize="xl" fontWeight="bold" color="gray.700">
                    {name}
                </Text>
                <Badge
                    colorScheme={color} 
                    px="3"
                    py="1"
                    borderRadius="full"
                    textTransform="uppercase"
                >
                    {status}
                </Badge>
            </Flex>
        </Box>
    );
};

export default Card;